<template>
  <button v-bind="attrs"
          v-on="$listeners">
    <slot>
      <span v-if="icon" :class="icon"></span>
    </slot>
  </button>
</template>

<script>
  export default {
    name: "smd-button",
    inheritAttrs: false,
    props: {
      icon: {type: String, default: ''},
      bg: {type: Boolean, default: false}
    },
    computed: {
      attrs() {
        return {
          ...this.$attrs,
          'icon-o' : !this.bg && this.icon.length > 0,
          'icon'   : this.bg && this.icon.length > 0
        };
      }
    }
  }
</script>